export const localeText = {
  // Sayfalama metinleri
  page: 'Sayfa',
  of: '/',
  to: '-',
  more: 'Daha Fazla',
  first: 'İlk',
  previous: 'Önceki',
  next: 'Sonraki',
  last: 'Son',
  pageSize: 'Sayfa Boyutu',

  // Genel metinler
  noRowsToShow: 'Gösterilecek Kayıt Yok',
  loadingOoo: 'Yükleniyor...',

  // Filtreleme metinleri
  filterOoo: 'Filtrele...',
  equals: 'Eşittir',
  notEqual: 'Eşit Değildir',
  empty: 'Boş',
  lessThan: 'Küçüktür',
  greaterThan: 'Büyüktür',
  lessThanOrEqual: 'Küçük veya Eşittir',
  greaterThanOrEqual: 'Büyük veya Eşittir',
  inRange: 'Aralıkta',
  contains: 'İçerir',
  notContains: 'İçermez',
  startsWith: 'İle Başlar',
  endsWith: 'İle Biter',

  // Seçim metinleri
  selectAll: 'Tümünü Seç',
  searchOoo: 'Ara...',
  blanks: 'Boş',

  // Sıralama metinleri
  sortAscending: 'Artan Sıralama',
  sortDescending: 'Azalan Sıralama',

  // Diğer metinler
  copyWithHeaders: 'Başlıklarla Kopyala',
  copy: 'Kopyala',
  ctrlC: 'Ctrl+C',
  paste: 'Yapıştır',
  ctrlV: 'Ctrl+V',
  export: 'Dışa Aktar',

  // Grup metinleri
  groupBy: 'Grupla',
  ungroupBy: 'Grubu Kaldır',
  resetColumns: 'Sütunları Sıfırla',
  expandAll: 'Tümünü Genişlet',
  collapseAll: 'Tümünü Daralt',

  // Filtre paneli
  clearFilter: 'Filtreyi Temizle',
  applyFilter: 'Filtreyi Uygula',
  resetFilter: 'Filtreyi Sıfırla',
};
